export default __webpack_public_path__ + "static/media/calendar.8dae1a28.svg";